import { Component, Input } from '@angular/core';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-item-invoice-tenant]',
  template: `
    <div class="d-flex px-3 py-2">
      <div class="flex-fill">
        <div>
          <h4 class="mb-0">Id #:  {{invoice.folio}}</h4>
          <p class="text-sm mb-0" style="font-size: 11px !important;">Folio fiscal: {{invoice.uuid}}</p>
          <p class="text-sm mb-0" style="font-size: 11px !important;">{{invoice?.settlement_name}}, {{invoice?.building_name}}, {{invoice?.unit_name}}</p>
        </div>
      </div>
      <div class="ms-auto align-self-center text-center">
        <p class="mb-0"><b>{{invoice?.total | currency}}</b></p>
      </div>
      <div class="align-self-center text-center mx-2">
        <fa-icon [icon]="icons.faDownload" size="1x" class="center-icon text-zazz"></fa-icon>
      </div>
    </div>
  `,
  styles: ``
})
export class ItemInvoiceTenantComponent {
  @Input() invoice: any;

  constructor(
    public catalogs: CatalogsService,
    public icons: IconsService
  ) { }

  get invoiceType() {
    return this.catalogs.tipoFactura.find((x: any) => this.invoice.tipo == x.id);
  }
}
